
import { useState } from "react";

function Register({ onLogin }) {

  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRegister = async (e) => {

    e.preventDefault();

    setMessage("");
    setError("");
    setLoading(true);

    try {

      const response = await fetch(
        "https://td9dmwg0-8000.inc1.devtunnels.ms/auth/register",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          credentials: "include",

          body: JSON.stringify({
            name: name,
            age: Number(age),
            email: email,
            password: password,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {

        if (Array.isArray(data.detail)) {

          setError(
            data.detail
              .map((err) => err.msg)
              .join(", ")
          );

        } else {

          setError(
            data.detail ||
            "Registration failed"
          );

        }

        return;
      }

      setMessage(
        data.msg ||
        data.message ||
        "Account created successfully!"
      );

      setName("");
      setAge("");
      setEmail("");
      setPassword("");

    } catch (err) {

      console.error(err);

      setError(
        "Unable to connect to server"
      );

    } finally {

      setLoading(false);

    }
  };

  return (
    <div>

      <div className="form-heading">

        <h2>Create account</h2>

        <p>
          Join us and get started today
        </p>

      </div>

      <form onSubmit={handleRegister}>

        <div className="input-group">

          <label>Full name</label>

          <div className="input-wrapper">

            <span className="input-icon">
              👤
            </span>

            <input
              type="text"
              placeholder="Your name"
              value={name}
              onChange={(e) =>
                setName(e.target.value)
              }
              required
            />

          </div>

        </div>

        <div className="input-row">

          <div className="input-group">

            <label>Age</label>

            <div className="input-wrapper">

              <span className="input-icon">
                #
              </span>

              <input
                type="number"
                placeholder="Age"
                min="1"
                max="120"
                value={age}
                onChange={(e) =>
                  setAge(e.target.value)
                }
                required
              />

            </div>

          </div>

          <div className="input-group">

            <label>Email</label>

            <div className="input-wrapper">

              <span className="input-icon">
                ✉
              </span>

              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) =>
                  setEmail(e.target.value)
                }
                required
              />

            </div>

          </div>

        </div>

        <div className="input-group">

          <label>Password</label>

          <div className="input-wrapper">

            <span className="input-icon">
              🔒
            </span>

            <input
              type="password"
              placeholder="Create password"
              value={password}
              onChange={(e) =>
                setPassword(e.target.value)
              }
              required
            />

          </div>

        </div>

        <button
          className="auth-button"
          type="submit"
          disabled={loading}
        >
          {loading
            ? "Creating account..."
            : "Create account"}
        </button>

        {message && (
          <div className="success-message">
            {message}
          </div>
        )}

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

      </form>

      <p className="bottom-text">

        Already have an account?

        <button
          type="button"
          onClick={onLogin}
        >
          Sign in
        </button>

      </p>

    </div>
  );
}

export default Register;

